import React from 'react';
import { useTranslation } from 'react-i18next';

import savingBank from '../../../assets/billingPayments/saving-bank.svg';

import styles from './Reimbursement.module.css';

export const DirectDeposit = ({ lastNumbers = '' }) => {
  const { t } = useTranslation('insurance');

  return (
    <div className={styles.reimbursementMethodCard}>
      <img alt="saving-bank" src={savingBank} />

      <span>{t('directDepositEding', { bankNumber: lastNumbers })}</span>
    </div>
  );
};
